export const heroImage =
  'https://cdn.magicpatterns.com/uploads/pWQpw91Wfax85BxWKbMT5u/ChatGPT_Image_17_sept_2026,_20_31_51-Photoroom.webp'

/** Enlace de pago. */
export const checkoutUrl = '#oferta'
export const price = '$19'
export const fullPrice = '$297'
export const bonusValue = '$119'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '6', label: 'Volúmenes técnicos' },
  { value: '+70', label: 'Sesiones listas' },
  { value: '5', label: 'Bonos exclusivos' },
]

export const heroBadges: string[] = [
  '100% en español',
  'Acceso inmediato',
  'PDF descargable',
  'Garantía 7 días',
]

/** El costo real de no tener el sistema correcto. */
export interface Cost {
  title: string
  detail: string
}

export const costs: Cost[] = [
  {
    title: 'Horas planificando sesiones cada semana',
    detail:
      'Tu tiempo libre desaparece antes de que el entrenamiento empiece.',
  },
  {
    title: 'Repetís los mismos ejercicios porque son fáciles',
    detail: 'Tus atletas dejan de mejorar. La variedad desaparece.',
  },
  {
    title: 'Ejercicios sin una ruta clara de progresión',
    detail: 'El entrenamiento se vuelve confuso en vez de productivo.',
  },
  {
    title: 'No sabés cómo corregir técnica en el momento',
    detail: 'Ves el error pero no tenés la progresión lista para arreglarlo.',
  },
  {
    title: 'Grupos mixtos en competencia por tu atención',
    detail: 'La planificación se vuelve un caos.',
  },
  {
    title: 'Semanas de competencia improvisadas desde cero',
    detail: 'No sabés si el atleta está fresco o sobrecargado.',
  },
]

/** Lo que incluye el acceso completo. */
export const included: string[] = [
  '6 volúmenes técnicos completos',
  '+70 sesiones listas para usar',
  `5 bonos exclusivos (valor ${bonusValue})`,
  '100% en español',
  'Acceso inmediato',
  'Formato PDF descargable',
  'Garantía de 7 días',
  'Pago en tu moneda local',
]

/** El cierre: lo que dejás de hacer y lo que ganás. */
export interface Outcome {
  text: string
  positive: boolean
}

export const outcomes: Outcome[] = [
  { text: 'Sin más horas buscando ejercicios', positive: false },
  { text: 'Sin ejercicios desconectados y sin progresión', positive: false },
  { text: 'Sin semanas de competencia improvisadas', positive: false },
  { text: 'Sin dudas sobre qué enseñar después', positive: false },
  { text: 'Sin grupos desordenados en la pista', positive: false },
  { text: 'Con más autoridad y claridad técnica', positive: true },
]
